import { useOnScrollToTop } from 'hooks/useScrollToTop';
import React, { useRef } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import { ETenantName } from 'redux/app/vessel/inspector/types';
import DeckLogEPSCoverBackPage from './DeckLogEPSCoverBackPage';
import { IStore } from 'redux/store';
import { vesselSelectors } from 'redux/app/vessel';
import { commonUtils } from 'redux/_common';

type OwnProps = {
	vesselId: string;
};
type DeckLogInspectorBackViewProps = PropsFromRedux & OwnProps;
function DeckLogInspectorBackView(props: DeckLogInspectorBackViewProps) {
	const { tenantName } = props;
	const topDivRef = useRef<HTMLDivElement | null>(null);
	useOnScrollToTop(topDivRef);
	return (
		<div className="w-full">
			<div className="h-0" ref={topDivRef} />
			{[ETenantName.EPS, ETenantName.DEFAULT]?.includes(tenantName) ? (
				<DeckLogEPSCoverBackPage />
			) : null}
		</div>
	);
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
	const tenantName: ETenantName = commonUtils.getTenantInfo(vesselInfo.tenantId ?? "") as ETenantName;
	return {
		tenantName,
	};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(DeckLogInspectorBackView);